import React, { useContext, useMemo } from 'react';
import { Caption1 } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const LanguageInfoBanner = () => {
  const i18n = useContext(I18nContext);

  const bannerMessage = useMemo(() => {
    const template = i18n.getString(_TL_('If you choose English, your campaign will target all LinkedIn member accounts in your selected {{bold}}Location{{/bold}}, regardless of their profile language settings.'));

    return (
      <ReactTemplate
        template={template}
        model={{ bold: text => <b>{text}</b> }}
      />
    );
  }, [i18n]);

  return (
    <MessageBar className="language-info-banner">
      <MessageBarBody>
        <Caption1>
          {bannerMessage}
        </Caption1>
      </MessageBarBody>
    </MessageBar>
  );
};
